export const style = {
  header: {
    size: 'lg',
    textAlign: 'center',
    paddingY: 6,
  },
  container: {
    direction: 'column',
    align: 'left',
    rowGap: 6,
  },
  employmentName: {
    size: 'lg',
    paddingTop: 4,
    fontWeight: 500,
  },
  buttons: {
    w: 'full',
    marginY: 6,
  },
  center: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingY: 24,
  },
};
